import React, {ErrorInfo} from 'react';
import {errorMessage} from 'Utils/common';
import Spinner from './spinner';
import './index.scss';

export interface BoundaryProps {
    className?: string;
    errorFallback?: (error: Error) => React.ReactNode;
    spinner?: React.ReactElement;
    children?: React.ReactNode;
}

export default class Boundary extends React.Component<BoundaryProps> {
    state = {
        error: null,
    };

    static getDerivedStateFromError(error: any) {
        return {error};
    }

    componentDidCatch(error: Error, info: ErrorInfo) {}

    render() {
        if (this.state.error) {
            if (this.props.errorFallback) {
                return this.props.errorFallback(this.state.error);
            }

            return (
                <div className={this.props.className}>
                    {errorMessage(this.state.error)}
                </div>
            );
        }

        return (
            <React.Suspense fallback={this.props.spinner || <Spinner />}>
                {this.props.children}
            </React.Suspense>
        );
    }
}
